import { useEffect } from 'react';

const difficultyStyles = {
  Easy:   'text-green-400 bg-green-400/10 border border-green-400/20',
  Medium: 'text-yellow-400 bg-yellow-400/10 border border-yellow-400/20',
  Hard:   'text-red-400 bg-red-400/10 border border-red-400/20',
};

const languageStyles = {
  JavaScript: 'text-purple-300 bg-purple-300/10 border border-purple-300/20',
  Java:       'text-orange-300 bg-orange-300/10 border border-orange-300/20',
  SQL:        'text-blue-300 bg-blue-300/10 border border-blue-300/20',
};

export default function DescriptionModal({ problem, onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    // Prevent background scroll
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  if (!problem) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" />

      {/* Panel */}
      <div
        className="relative bg-gray-950 border border-gray-800 rounded-xl w-full max-w-2xl max-h-[82vh] flex flex-col shadow-2xl shadow-purple-950/20"
        onClick={e => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-start justify-between px-6 py-4 border-b border-gray-800 flex-shrink-0">
          <div>
            <div className="flex items-center gap-2 mb-2 flex-wrap">
              <span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${difficultyStyles[problem.difficulty]}`}>
                {problem.difficulty}
              </span>
              <span className={`text-xs font-medium px-2.5 py-1 rounded-full ${languageStyles[problem.language]}`}>
                {problem.language}
              </span>
            </div>
            <h2 className="text-base font-bold text-white leading-snug pr-8">{problem.title}</h2>
          </div>
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-600 hover:text-gray-400 transition-colors p-1 rounded"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Body — scrollable */}
        <div className="overflow-y-auto flex-1 px-6 py-5">
          {problem.fullDescription ? (
            <pre className="text-gray-300 text-sm leading-relaxed whitespace-pre-wrap font-mono">
              {problem.fullDescription}
            </pre>
          ) : (
            <p className="text-gray-500 text-sm italic">No full description available.</p>
          )}
        </div>

        {/* Footer */}
        <div className="px-6 py-3.5 border-t border-gray-800 flex justify-end flex-shrink-0">
          <a
            href={problem.leetcodeUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-purple-400 hover:text-purple-300 text-sm font-medium transition-colors"
          >
            Open on LeetCode
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
}
